// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Subscriptions_GatewayMapResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Subscriptions_GatewayMapResponse — response for GET /subscriptions/gateways/map.
 *
 * Returns the full enablement map: for each feature, each provider's
 * enabled state (from DB), code-declared capabilities (from GatewayCapabilities),
 * and the supported currencies list (from GatewayCapabilities::getCurrencies()).
 *
 * Shape:
 * {
 *   "features": {
 *     "<feature>": {
 *       "<provider_code>": {
 *         "enabled": bool,
 *         "capabilities": { "<op>": bool, ... },
 *         "currencies": ["BRL", "USD", ...]
 *       },
 *       ...
 *     },
 *     ...
 *   }
 * }
 *
 * currencies is the list of ISO 4217 codes the provider can charge in
 * (["*"] for 'gatewaytest' — accepts any currency in test environments).
 * Providers not registered in code get an empty currencies array.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Subscriptions_GatewayMapResponseDados {
features: Record<string, Record<string, {
enabled: boolean,
capabilities: Record<string, boolean>,
currencies: string[],
}>>
}

export type Subscriptions_GatewayMapResponse = ApiResponse<Subscriptions_GatewayMapResponseDados>;

registerResponseContract('Subscriptions_GatewayMapResponse', {
  features: { type: 'object',  required: true },
})
